import { render } from "./appresourceModel.vue?vue&type=template&id=6879e7eb&scoped=true"
import script from "./appresourceModel.js?vue&type=script&lang=js"
export * from "./appresourceModel.js?vue&type=script&lang=js"

import "./appresourceModel.vue?vue&type=style&index=0&id=6879e7eb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6879e7eb"]])

export default __exports__